import { Modal, Typography } from '@mui/material';
import { FC } from 'react';
import { Container, Title, Subtitle, Btn } from './DeactivatedUserModal.styles';
import { useThemeLayout } from '../../hooks/useThemeLayout';
import { DeactivatedModalStrings } from '../../localization/en';
import { useTypedSelector } from '../../../store/store';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const DeactivatedUserModal: FC<Props> = ({ isOpen, onClose }) => {
  const { name } = useTypedSelector((state) => state.account.account);
  const { isDarkTheme, themeBackgroundColor, isThemeLayoutEnabled, themeTextColor } = useThemeLayout();

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Container
        sx={{
          background: isThemeLayoutEnabled ? themeBackgroundColor : '#fff',
        }}
      >
        <Title color={isThemeLayoutEnabled ? themeTextColor : '#000'}>
          {DeactivatedModalStrings.Title}
        </Title>
        <Subtitle as={Typography} mt="3px" color={isDarkTheme ? themeTextColor : '#8B89A0'}>
          {DeactivatedModalStrings.AccountDeactivated}
        </Subtitle>
        <Subtitle as={Typography} color={isDarkTheme ? themeTextColor : '#8B89A0'}>
          {name}.
        </Subtitle>

        <Btn size="small" variant="contained" onClick={onClose}>
          {DeactivatedModalStrings.Cancel}
        </Btn>
      </Container>
    </Modal>
  );
};
